import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
//import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import ListItemText from '@material-ui/core/ListItemText'
import ListItem from '@material-ui/core/ListItem'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'

import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import blue from '@material-ui/core/colors/blue'
import grey from '@material-ui/core/colors/grey'
//import Icon from '@material-ui/core/Icon'
//import DoneIcon from '@material-ui/icons/Done';

import CardLeaseDetails from './CardLeaseDetails'

import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { handleChangeStatus } from '../../actions/enquiries'

import * as API from '../../utils/api'
import { formatComment } from '../../helpers'

const styles = theme => ({
  appBar: {
    position: 'fixed',
    backgroundColor: '#f5f5f5',
    color: '#414042'
  },
  root: {
    width: 'calc(100% + 4px)',
    marginTop: '64px',
    padding: '10px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '56px',
      padding: '5px'
    }
  },
  toolbar: {
  	padding: '0'
  },
  flex: {
    flex: 1,
  },
  cardHeader: {
    fontWeight: '500'
  },
  buildingItem: {
    padding: '0',
    fontSize: '0.9em'
  },
  buildingPhoto: {
    width: '120px'
  },
  listItemPrimary: {
  	color: 'rgba(0, 0, 0, 0.54)'
  },
  listItemSecondary: {
  	color: 'rgba(0, 0, 0, 0.87)'
  },
  commentItemPrimary: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  commentItemSecondary: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.8125rem',
    fontStyle: 'italic'
  },
  statusSelect: {
  	marginRight: '15px',
  },
  statusIcon: {
    marginRight: 10
  }
});

class EnquiryPage extends Component {
	state = {
    statusId: '',
    enquiry: {},
    redirect: false,
    snackbarOpen: false
  }

  componentDidMount () {
    const { id, accountId } = this.props

    API.getEnquiry(id)
      .then((enquiry) => {
        this.setState(() => ({
          statusId: enquiry.statusId === null ? '' : enquiry.statusId,
          enquiry,
          redirect: enquiry.accountId !== accountId ? true : false
        }))
      })
  }

  handleChangeStatus = e => {
  	const statusId = e.target.value
    const { enquiry } = this.state
  	const { dispatch, userId } = this.props

  	if (statusId !== '' && statusId !== this.state.statusId) {
  		//console.log('change enquiry ', enquiry.id, ': ', this.state.statusId, ' -> ', statusId)
  		dispatch(handleChangeStatus(enquiry.id, statusId, userId))

	  	this.setState(() => ({
				statusId
			}))

      this.handleOpenSnackbar()
  	}
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  handleGoBack = () => {
    const { id, classes, accountId, comments, history } = this.props

    if (history.action === 'PUSH') {
      history.goBack()
    } else {
      history.push('/enquiries')
    }
  }

	render() {
		const { id, classes, accountId, comments, history } = this.props
    const { statusId, enquiry, redirect } = this.state
    const selectedBuildings = enquiry ? enquiry.selectedBuildings : []
		//const comments = enquiry ? enquiry.comments : []

		//console.log(enquiry)

    /*if (redirect) {
      return <Redirect to='/enquiries' />
    }*/

		const enquiryItems = {
      company: { label: 'Company', data: enquiry.company },
      fullname: { label: 'First name and surname', data: enquiry.fullname },
      email: { label: 'E-mail', data: enquiry.email },
      phone: { label: 'Phone', data: enquiry.phone },
      commencementDate: { label: 'Commencement date', data: enquiry.commencementDate },
      leaseTerm: { label: 'Lease term', data: enquiry.leaseTerm },
      numberOfEmployees: { label: 'Number of employees', data: enquiry.numberOfEmployees },
      space: { label: 'Space', data: enquiry.space },
      requirements: { label: 'Additional requirements', data: enquiry.requirements }
    }

    const enquiryStatuses = {
    	1: { id: '1', name: 'New', icon: 'flag', color: red[800]},
    	2: { id: '2', name: 'Confirmed', icon: 'check', color: green[500]},
    	3: { id: '3', name: 'Rejected', icon: 'block', color: grey[500]},
    	4: { id: '4', name: 'Finalized', icon: 'check', color: blue[500]},
    	5: { id: '5', name: 'Canceled', icon: 'highlight_off', color: grey[900]}
    }

		return (
			<div>
        <AppBar className={classes.appBar}>
          <Toolbar className={classes.toolbar}>

            <IconButton color="inherit" onClick={this.handleGoBack}>
              <KeyboardBackspaceIcon />
            </IconButton>

            <Typography variant="title" color="inherit" className='enquiry-title'>
              {enquiry.title}
            </Typography>
            <FormControl component="fieldset">
	          	<Select
		            value={statusId}
		            onChange={this.handleChangeStatus}
		            displayEmpty
		            name="statusId"
		            /*classes={{ select: classes.statusSelect, icon: {display: 'none'} }}*/
		            style={{ marginRight: '10px' }}
		          >
		          	{statusId === '' && (
		          		<MenuItem value="">
			              <em>change status</em>
			            </MenuItem>)}

		            { Object.keys(enquiryStatuses).map((status) =>
									<MenuItem key={enquiryStatuses[status].id} value={enquiryStatuses[status].id} style={{ color: enquiryStatuses[status].color }}>
										{/*<Icon className={classes.statusIcon} style={{ color: enquiryStatuses[status].color }}>
							        {enquiryStatuses[status].icon}
							      </Icon>*/}
										{enquiryStatuses[status].name}
									</MenuItem>
								)}
		          </Select>
		        </FormControl>
          </Toolbar>
        </AppBar>

        <Grid container spacing={8} className={classes.root}>
          <Grid item xs={12} sm={4} md={4} style={{ padding: '10px' }}>
             <Card>
              <CardHeader
                title="Company data"
                classes={{ title: classes.cardHeader }}
              />
              <Divider />
              <List>
              	{ Object.keys(enquiryItems).map((item) =>
                  <ListItem key={item}>
	                  <ListItemText
	                    primary={enquiryItems[item].label}
	                    secondary={enquiryItems[item].data}
	                    classes={{ primary: classes.listItemPrimary, secondary: classes.listItemSecondary }}
	                  />
                  </ListItem>
                )}
              </List>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4} md={4} style={{ padding: '10px' }}>
            <Card>
              <CardHeader
                title="Selected buildings"
                classes={{ title: classes.cardHeader }}
              />
              <Divider />
              <List style={{ padding: '0' }}>
                {typeof selectedBuildings === 'object' && selectedBuildings.map((building) =>
                	<Fragment key={building.id}>
                    <Link to={`/office/${building.id}`}>
  	                  <ListItem className={classes.buildingItem}>
  		                  <img src={building.photo} alt={building.name} className={classes.buildingPhoto} />
                      	<ListItemText secondary={building.name} classes={{ secondary: classes.listItemSecondary }} />
  	                  </ListItem>
                    </Link>
	                  <Divider />
                  </Fragment>
                )}
              </List>
            </Card>

            {statusId === '4' && (
              <CardLeaseDetails id={id} data={enquiry} />)}
          </Grid>
          <Grid item xs={12} sm={4} md={4} style={{ padding: '10px' }}>
            <Card>
              <CardHeader
                title="Status update"
                classes={{ title: classes.cardHeader }}
              />
              <Divider />
              <List>
                {typeof comments === 'object' && comments.map((item, index) => (
                  <ListItem key={index}>
                    {item.userAvatar ? <Avatar alt={item.userName} src={`/static/images/avatars/${item.userAvatar}`} /> : <Avatar style={{backgroundColor: red[500]}}>{item.userInitials}</Avatar>}
                    <ListItemText
                      primary={`${item.userName} (${item.createdOn})`}
                      secondary={item.comment}
                      classes={{ primary: classes.commentItemPrimary, secondary: classes.commentItemSecondary }}
                    />
                  </ListItem>
                ))}
                {typeof comments === 'object' && Object.keys(comments).length === 0 && (
                  <ListItem>
                    <ListItemText
                      secondary="No updates yet"
                      classes={{ secondary: classes.commentItemSecondary }}
                    />
                  </ListItem>
                )}
              </List>
            </Card>
          </Grid>
        </Grid>

        <Snackbar
          open={this.state.snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Status has been changed.</span>}
        />
      </div>
		)
	}
}

function mapStateToProps ({ enquiries, authedUser }, props) {
  const { id } = props.match.params
  const comments = enquiries[id].comments.map((comment) => formatComment(comment)).sort((a,b) => (b.parsedDate - a.parsedDate))

  //console.log(comments)

  return {
    id,
    userId: authedUser.id,
    accountId: authedUser.accountId,
    comments
  }
}

export default connect(mapStateToProps)(withRouter(withStyles(styles)(EnquiryPage)))


// WEBPACK FOOTER //
// ./src/components/Enquiries/EnquiryPage.js